<script setup lang="ts">
import { useCvButtonNavigation } from '../useCvButtonNavigation';
import ButtonClose from 'theme/components/atoms/ButtonClose.vue';
import NuxtLinkFlat from 'theme/components/atoms/NuxtLinkFlat.vue';

withDefaults(
  defineProps<{
    isActive?: boolean;
  }>(),
  {
    isActive: false,
  }
);

const emits = defineEmits<{
  close: [];
}>();

const items = [
  {
    to: '#service',
    text: 'サービスについて',
  },
  {
    to: '#introduction',
    text: 'IFAご紹介',
  },
  {
    to: '#case',
    text: '相談事例',
  },
  {
    to: '#voice',
    text: '体験者の声',
  },
];

const closeMenu = () => emits('close');

const { cvButtonTo } = useCvButtonNavigation();
</script>

<template>
  <div :class="{ 'menu--show': isActive }" class="menu">
    <div class="menu__layer" />
    <div class="menu__contents">
      <ButtonClose class="menu__close" @click="closeMenu" />
      <nav class="menu__nav">
        <ul class="menu__navLists lists">
          <li v-for="item in items" :key="item.to" class="lists__item">
            <a :href="item.to" class="lists__link">{{ item.text }}</a>
          </li>
        </ul>
      </nav>

      <NuxtLinkFlat
        class="menu__button button"
        :to="cvButtonTo"
        variant="conversion"
        >まずは診断</NuxtLinkFlat
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.menu {
  $root: &;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100vh;
  padding: 0 32px;
  visibility: hidden;

  &--show {
    visibility: visible;
  }

  &__layer {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: $color-surface-backdrop;
    transform-origin: left top;
    transition:
      transform 0.8s cubic-bezier(0.3, 0.3, 0.12, 1) 0.1s,
      height 0.7s;
  }

  &__close {
    display: block;
    position: absolute;
    top: 24px;
    right: 24px;
    width: 32px;
    height: 32px;
  }

  &__contents {
    position: absolute;
    top: 0;
    right: 0;
    width: 280px;
    height: 100%;
    padding: 88px 32px;
    background: $color-surface-primary;
  }

  &__button {
    margin-top: 40px;
  }
}

.lists {
  $root: &;

  display: grid;
  gap: 32px;

  &__item {
    position: relative;
  }

  &__link {
    display: block;
    font-size: 16px;
    font-weight: bold;
    color: $color-text-and-object-high-emphasis;
    line-height: 1;
  }
}

.button {
  width: 100%;
  padding: 8px 16px;
  font-size: 14px;
}
</style>
